import React, { useState } from 'react';
import { User, Mail, Phone, Lock, Eye, EyeOff, ChevronRight } from 'lucide-react';
import { FieldError, FieldWrap, cls, getErr } from './helpers';

const StepCompte = ({ data, onChange, onNext }) => {
    const [showPwd, setShowPwd]         = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [errors, setErrors]           = useState({});

    const validate = () => {
        const e = {};
        if (!data.first_name.trim()) e.first_name = "Le prénom est requis";
        if (!data.last_name.trim())  e.last_name  = "Le nom est requis";
        if (!data.email.trim())      e.email      = "L'email est requis";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) e.email = "Email invalide";
        if (!data.password)          e.password   = "Le mot de passe est requis";
        else if (data.password.length < 8) e.password = "Minimum 8 caractères";
        if (data.password !== data.confirm_password) e.confirm_password = "Les mots de passe ne correspondent pas";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const set = (field) => (e) => onChange({ ...data, [field]: e.target.value });

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Prénom <span className="text-red-500">*</span></label>
                    <FieldWrap icon={User}><input type="text" value={data.first_name} onChange={set('first_name')} className={cls(errors.first_name)} placeholder="Prénom" /></FieldWrap>
                    <FieldError msg={getErr(errors, 'first_name')} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Nom <span className="text-red-500">*</span></label>
                    <FieldWrap icon={User}><input type="text" value={data.last_name} onChange={set('last_name')} className={cls(errors.last_name)} placeholder="Nom" /></FieldWrap>
                    <FieldError msg={getErr(errors, 'last_name')} />
                </div>
            </div>
            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Email <span className="text-red-500">*</span></label>
                <FieldWrap icon={Mail}><input type="email" value={data.email} onChange={set('email')} className={cls(errors.email)} placeholder="exemple@email.com" /></FieldWrap>
                <FieldError msg={getErr(errors, 'email')} />
            </div>
            <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Téléphone</label>
                <FieldWrap icon={Phone}><input type="tel" value={data.telephone} onChange={set('telephone')} className={cls(false)} placeholder="Optionnel" /></FieldWrap>
            </div>
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Mot de passe <span className="text-red-500">*</span></label>
                    <FieldWrap icon={Lock}>
                        <input type={showPwd ? 'text' : 'password'} value={data.password} onChange={set('password')} className={cls(errors.password) + ' pr-9'} placeholder="Min. 8 caractères" />
                        <button type="button" onClick={() => setShowPwd(v => !v)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400">
                            {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        </button>
                    </FieldWrap>
                    <FieldError msg={getErr(errors, 'password')} />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Confirmation <span className="text-red-500">*</span></label>
                    <FieldWrap icon={Lock}>
                        <input type={showConfirm ? 'text' : 'password'} value={data.confirm_password} onChange={set('confirm_password')} className={cls(errors.confirm_password) + ' pr-9'} placeholder="Répétez" />
                        <button type="button" onClick={() => setShowConfirm(v => !v)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400">
                            {showConfirm ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        </button>
                    </FieldWrap>
                    <FieldError msg={getErr(errors, 'confirm_password')} />
                </div>
            </div>
            <button onClick={() => { if (validate()) onNext(); }} className="w-full flex justify-center items-center gap-2 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg text-sm font-medium transition">
                Continuer <ChevronRight className="h-4 w-4" />
            </button>
        </div>
    );
};

export default StepCompte;
